<template>
  <div class="panel-modale">
    <div class="panel-modale__inner" :style="getModalFormWidth">
      <button class="panel-modale__close" @click="$emit('close')">✖</button>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    closeButton: {
      type: Boolean,
      default: true,
    },
    width: String,
  },
  metaInfo() {
    return {
      bodyAttrs: {
        'data-modal': '',
      },
    };
  },
  computed: {
    getModalFormWidth() {
      return {
        '--modal_form_width': this.width ? this.width : undefined,
      };
    },
  },
};
</script>

<style>
body[data-modal] {
  overflow: hidden;
  height: 100% !important;
}
</style>

<style lang="scss" scoped>
.panel-modale {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: fixed;
  padding: 1em;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 10000;
  background-color: rgba(0, 0, 0, .4);

  &__inner {
    background-color: #fff;
    position: relative;
    max-width: 1050px;
    margin: 0 auto;
    padding: 40px;
    width: var(--modal_form_width, 100%);
    box-shadow: 0 0 20px rgba(0, 0, 0, .4);
  }

  &__close {
    position: absolute;
    right: 1em;
    top: 1em;
    width: 1em;
    height: 1em;
    font-size: 1em;
    background-color: transparent;
    border-width: 0;
    color: rgba(0, 0, 0, .4);
    cursor: pointer;
    transition: color .2s ease;

    &:hover {
      color: rgba(0, 0, 0, .8);
    }

    &:active,
    &:focus {
      outline: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Modal.vue?3807ca5a